import { render, staticRenderFns } from "./KT-MyPagesComponent.vue?vue&type=template&id=5bd52d35&"
import script from "./KT-MyPagesComponent.vue?vue&type=script&lang=js&"
export * from "./KT-MyPagesComponent.vue?vue&type=script&lang=js&"
import style0 from "./KT-MyPagesComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports